import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { useTranslation } from 'react-i18next';

import { StyledButtonContainer } from '../../styles/input-row';

interface DeleteRowButtonProps {
    index: number;
    removeRow: (index: number) => void;
}

const DeleteRowButton: React.FC<DeleteRowButtonProps> = ({ index, removeRow }) => {
    const { t } = useTranslation('generic');

    return (
        <StyledButtonContainer>
            <DeleteOutlineIcon color="primary" aria-label={t('remove-row')} cursor="pointer" onClick={() => removeRow(index)} />
        </StyledButtonContainer>
    );
};

export default DeleteRowButton;
